<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_distribution"
        title="Funktionen / Module"
        @save="saveFirmFunctions">
        <h2>Funktionen</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Aktiv"
                property="active"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="SilverDAT 3 / MyClaim Firma"
                property="isDatFirm"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Externer Gutachter"
                property="isExternalAppraiser"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Aktenanlage durch Werkstattauftrag"
                property="canCreateRecordsWithCross"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="VIN Abfragen aktivieren"
                property="isVinRequestEnabled"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="2-Faktor Authentifizierung erforderlich"
                property="requires2fa"
                type="checkbox">
                <template v-if="firmGroupOverride('requires2fa')" v-slot:display-value>
                    <span><b>Ja (von FG)</b><br></span>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Gutachterrechnung ausblenden"
                property="shouldHideAppraiserFees"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Vermerk-E-Mails an Firmenbenutzer senden"
                property="sendNoteEmailsToFirmUsers"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Schadenpositionen mit KI anlegen"
                property="canCreateCostUnitsWithOcr"
                type="checkbox">
                <template v-if="firmGroupOverride('canCreateCostUnitsWithOcr')" v-slot:display-value>
                    <span><b>Ja (von FG)</b><br></span>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Nutzung von Kundenvorlagen"
                property="canUseCustomerTemplates"
                type="checkbox">
                <template v-if="firmGroupOverride('canUseCustomerTemplates')" v-slot:display-value>
                    <span><b>Ja (von FG)</b><br></span>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="BlueNow Debitoren Key"
                property="blueNowDebitorKey"
                :required="false"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="PIN externer Dienstleister"
                property="externalPin"
                :required="false"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="bezahl.de Organisation"
                :options-loader="loadBezahlDeOrgOptions"
                property="bezahlDeOrg"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('bezahlDeOrg')"
                class="col-6"
                :form-context="formContext"
                label="bezahl.de Standort-ID"
                property="bezahlDeLocation"
                type="text"/>
        </b-row>
        <firm-bezahl-de-org-create-modal
            v-if="formContext.isInEditMode"
            :firm-id="Number(firmId)"
            @org-created="reloadFirmFunctionsForm"/>
        <h2>Module</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                :hide-label="true"
                label="Schaden-Manager aktiv"
                property="damageModuleActive"
                type="checkbox"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('damageModuleActive')"
                class="col-6"
                :form-context="formContext"
                label="Beginn Aktivierung"
                :max-date="null"
                property="damageModuleDateBegin"
                required
                type="datepicker"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('damageModuleActive')"
                class="col-6"
                :form-context="formContext"
                label="Beginn Abrechnung"
                :max-date="null"
                property="damageModuleBillingDateBegin"
                type="datepicker"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('damageModuleActive')"
                class="col-6"
                :form-context="formContext"
                label="Ende Aktivierung"
                :max-date="null"
                property="damageModuleDateEnd"
                type="datepicker"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('damageModuleActive')"
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Anlieferungs-Vorgänge aktivieren"
                property="enableDeliveryClaims"
                type="checkbox">
                <template v-if="firmGroupOverride('enableDeliveryClaims')" v-slot:display-value>
                    <span><b>Ja (von FG)</b><br></span>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('damageModuleActive')"
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Inkasso-Vorgänge aktivieren"
                property="enableDebtCollectionClaims"
                :required="false"
                type="checkbox"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('damageModuleActive')"
                class="col-6"
                :form-context="formContext"
                :hide-label="true"
                label="Regress-Vorgänge aktivieren"
                property="enableRegressClaims"
                :required="false"
                type="checkbox"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                :hide-label="true"
                label="Mobilitäts-Manager aktiv"
                property="rentModuleActive"
                type="checkbox"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('rentModuleActive')"
                class="col-6"
                :form-context="formContext"
                label="Beginn Aktivierung"
                :max-date="null"
                property="rentModuleDateBegin"
                required
                type="datepicker"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('rentModuleActive')"
                class="col-6"
                :form-context="formContext"
                label="Beginn Abrechnung"
                :max-date="null"
                property="rentModuleBillingDateBegin"
                type="datepicker"/>
            <csp-desktop-info-card-element
                v-if="formContext.form.getProperty('rentModuleActive')"
                class="col-6"
                :form-context="formContext"
                label="Ende Aktivierung"
                :max-date="null"
                property="rentModuleDateEnd"
                type="datepicker"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FirmBezahlDeOrgCreateModal from './FirmBezahlDeOrgCreateModal.vue';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmFunctions',
        components: {
            FirmBezahlDeOrgCreateModal,
        },
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        emits: ['saved'],
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
        },
        methods: {
            loadBezahlDeOrgOptions() {
                return firmRepository.getBezahlDeOptions(this.firmId);
            },
            reloadFirmFunctionsForm() {
                this.reloadFormData(this.formContext, (objectId, attributes) => {
                    return firmRepository.reloadFirmFunctions(objectId, attributes);
                });
            },
            firmGroupOverride(propertyName) {
                let firmGroupValue = this.formContext.form.getContextData()[propertyName]?.contextData?.firmGroupValue;
                let firmValue = this.formContext.form.getDataOfProperty(propertyName);
                if (firmGroupValue === true && firmValue === false) {
                    return true;
                }
                return false;
            },
            saveFirmFunctions(formContext) {
                const hasBezahlDeLocationField = Object.prototype.hasOwnProperty.call(
                    formContext.complexFields,
                    'bezahlDeLocation'
                );
                if (hasBezahlDeLocationField && !formContext.form.getProperty('bezahlDeOrg')) {
                    formContext.form.setProperty('bezahlDeLocation', null);
                }
                const saveFunction = (objectId, postData) => {
                    postData = this.getFilteredPostData(postData);
                    return firmRepository.saveFirmFunctions(objectId, postData);
                }
                this.saveFormData(formContext, saveFunction).then(() => {
                    this.$emit('saved');
                });
            },
            getFilteredPostData(postData) {
                // work on clone to leave original form data object unchanged
                postData = structuredClone(postData);

                if (!postData.damageModuleActive) {
                    // remove other damage module fields
                    delete postData.damageModuleDateBegin;
                    delete postData.damageModuleBillingDateBegin;
                    delete postData.damageModuleDateEnd;
                }

                if (!postData.rentModuleActive) {
                    // remove other rent module fields
                    delete postData.rentModuleDateBegin;
                    delete postData.rentModuleBillingDateBegin;
                    delete postData.rentModuleDateEnd;
                }

                return postData;
            },
        },
    }
</script>
